var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      title: _vm.$t("label_essweb_Announcement_form_viewTitle"),
      backgroundClass: "white",
    },
    scopedSlots: _vm._u([
      {
        key: "appendTitle",
        fn: function () {
          return [
            _c("StatusChip", {
              attrs: {
                "content-class": "mx-2",
                icon: "",
                slideColor:
                  Number(_vm.announcementData.send_status) == 0
                    ? "green"
                    : Number(_vm.announcementData.send_status) == 1
                    ? "orange"
                    : Number(_vm.announcementData.send_status) == 2
                    ? "grey"
                    : "grey",
              },
              scopedSlots: _vm._u([
                {
                  key: "status",
                  fn: function () {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getCommonLangValue(
                              _vm.announcementData.send_status_detail
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "nav-actions",
        fn: function () {
          return [
            Number(_vm.announcementData.send_status) === 1 &&
            _vm.hasBtn("end-company-announcement")
              ? _c(
                  "v-btn",
                  {
                    staticClass: "mr-2 text-capitalize white--text",
                    attrs: { color: "red", ripple: false },
                    on: {
                      click: function ($event) {
                        _vm
                          .$confirmDo(
                            _vm.$t(
                              "label_essweb_admin_Announcement_list_title"
                            ),
                            _vm.$t(
                              "message_essweb_Announcement_form_revocationTitle"
                            ),
                            _vm.$t(
                              "message_essweb_Announcement_form_isRevocationLabel"
                            ),
                            null,
                            _vm.$t(
                              "message_essweb_Announcement_form_revocationBtnLabel"
                            )
                          )
                          .then(function (res) {
                            res ? _vm.toRefuse() : null
                          })
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("label_essweb_Announcement_form_toEndBtnLabel")
                      )
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { align: "center", justify: "start" } },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            readonly: "",
                            filled: false,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            maxlength: "200",
                            label: _vm.$t(
                              "label_essweb_Announcement_form_announcementTitleLabel"
                            ),
                          },
                          model: {
                            value: _vm.announcementData.message_title,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "message_title",
                                $$v
                              )
                            },
                            expression: "announcementData.message_title",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            readonly: "",
                            filled: false,
                            value:
                              _vm.$getDateTime(
                                _vm.announcementData.send_start_utc_datetime,
                                "YYYY/MM/DD HH:mm"
                              ) +
                              " - " +
                              _vm.$getDateTime(
                                _vm.announcementData.send_end_utc_datetime,
                                "YYYY/MM/DD HH:mm"
                              ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_Announcement_form_publicTimeLabel"
                            ),
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_Announcement_form_orgLeaveLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-combobox", {
                          attrs: {
                            items: [],
                            multiple: "",
                            readonly: "",
                            filled: false,
                            "append-icon": "",
                            "item-color": "transparent",
                            "small-chips": "",
                            rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                            dense: "",
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  data.index < _vm.$selectSetting.maxChips
                                    ? _c(
                                        "v-chip",
                                        _vm._b(
                                          {
                                            staticClass: "mx-1 my-1",
                                            attrs: {
                                              "input-value": data.selected,
                                            },
                                            on: { click: data.select },
                                          },
                                          "v-chip",
                                          data.attrs,
                                          false
                                        ),
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  data.item.org_level_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  data.index === _vm.$selectSetting.maxChips
                                    ? _c(
                                        "span",
                                        { staticClass: "text--primary py-2" },
                                        [
                                          _vm._v(
                                            " ..." +
                                              _vm._s(
                                                _vm.announcementData
                                                  .send_org_level_uuid.length -
                                                  _vm.$selectSetting.maxChips
                                              ) +
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_selection_moreItemLabel"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                            {
                              key: "no-data",
                              fn: function () {
                                return [
                                  _vm.orgData.length == 0
                                    ? _c("noContent")
                                    : _c("v-treeview", {
                                        attrs: {
                                          selectable: "",
                                          "open-all": "",
                                          "open-on-click": "",
                                          "selected-color": "primary",
                                          items: _vm.orgData,
                                          "item-key": "uuid",
                                          search: _vm.search,
                                          filter: _vm.filter,
                                          "return-object": "",
                                          "item-text": "org_level_shortcode",
                                          "item-children": "son_org",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "label",
                                            fn: function (ref) {
                                              var item = ref.item
                                              return [
                                                _c("span", {
                                                  staticClass:
                                                    "text--secondary",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.hightLightKeyword(
                                                        item.org_level_name,
                                                        _vm.search
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                        model: {
                                          value:
                                            _vm.announcementData
                                              .send_org_level_uuid,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.announcementData,
                                              "send_org_level_uuid",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "announcementData.send_org_level_uuid",
                                        },
                                      }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.curSend,
                            callback: function ($$v) {
                              _vm.curSend = $$v
                            },
                            expression: "curSend",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            readonly: "",
                            filled: false,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            maxlength: "200",
                            label: _vm.$t(
                              "label_essweb_Announcement_form_contentLabel"
                            ),
                          },
                          model: {
                            value: _vm.announcementData.message_content,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.announcementData,
                                "message_content",
                                $$v
                              )
                            },
                            expression: "announcementData.message_content",
                          },
                        }),
                      ],
                      1
                    ),
                    Number(_vm.announcementData.send_status) === 1
                      ? _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "12",
                              md: "12",
                              lg: "12",
                              cols: "12",
                            },
                          },
                          [
                            _c(
                              "v-sheet",
                              {
                                staticClass: "mrc_text_require text--secondary",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_Announcement_form_hasBeenReadLabel"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                "single-line": "",
                                height: "42",
                                value:
                                  (_vm.announcementData.read_num || 0) +
                                  "/" +
                                  (_vm.announcementData.total || 0),
                                dense: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append-outer",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "text-capitalize",
                                            attrs: {
                                              outlined: "",
                                              color: "primary",
                                            },
                                            on: { click: _vm.showDetail },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_Announcement_form_hasBeenReadDetailBtnLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1540282940
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("showDetailReaded", {
              attrs: {
                show: _vm.showDetailReadedDialog,
                curUuid: _vm.$route.params.id,
              },
              on: {
                close: function ($event) {
                  _vm.showDetailReadedDialog = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }